enum WorkOrderPriority {
  None = "None",
  P1Emergency = "P1Emergency",
  P2SameDayService = "P2SameDayService",
  P3NextDayService = "P3NextDayService",
  P4ScheduledService = "P4ScheduledService",
  P5PreventativeServices = "P5PreventativeServices",
}

export default WorkOrderPriority;
